<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	let {
		children,
		skipAnimation = false,
		class: classList = undefined,
		containerClasses = undefined,
		id = undefined
	} = $props();
</script>

<div class={twMerge(classList, 'flex flex-col items-center justify-center')} {id}>
	<div
		class={twMerge(containerClasses, 'w-full px-4 md:px-28 lg:px-36 xl:px-40 2xl:max-w-7xl')}
		data-aos={!skipAnimation ? 'slide-in-blurred-bottom' : undefined}
	>
		{@render children()}
	</div>
</div>
